/** Identifier systems on a member's `Patient`. Read through `Member.Identifier`. */
export const MEMBER_IDENTIFIER = {
  Email: "vibrant.members.email",

  // Integration identifiers.
  MedmoPatientId: "medmo.patients",
  PhotonPatientId: "photon.patients",
  DosespotId: "https://dosespot.com/patient-id",
  FullscriptPatientId: "fullscript.patients",
  HintPatientId: "hint.patients",
  HealthiePatientId: "healthie.patients",
  VitalUserId: "vital.users",
  CalUserId: "cal.users",
  CalUsername: "cal.users.username",
  CalManagedEmail: "cal.users.email",
} as const;
